import {
  GET_ADMIN_USERS_LIST_SUCCESS,
  SELECT_USER,
  SELECT_USER_SUCCESS,
  UNSELECT_USER,
  CLEAR_SELECTED_USER
} from '../constants'

const adminUserReducer = (
  state = {
    usersList: [],
    selectedUser: {},
    freezeSelectUser: false,
    clearUserInfo: false
  },
  action
) => {
  switch (action.type) {
    case GET_ADMIN_USERS_LIST_SUCCESS:
      return { ...state, usersList: action.result }

    case SELECT_USER:
      return { ...state, freezeSelectUser: true }

    case SELECT_USER_SUCCESS:
      return { ...state, selectedUser: action.data, clearUserInfo: false }

    case UNSELECT_USER:
      return { ...state, usersList: [], selectedUser: {} }

    case CLEAR_SELECTED_USER:
      return {
        ...state,
        selectedUser: {},
        clearUserInfo: true,
        freezeSelectUser: false
      }

    default:
      return state
  }
}

export default adminUserReducer
